module.exports = __webpack_public_path__ + "img/127.8.40c295d2.png";